import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { SlackScreen } from "../../screens/settings/SlackScreen.tsx";

/** `/settings/slack`: add Adea to Slack and choose where findings go. */
export const Route = createFileRoute("/_app/settings/slack")({
  validateSearch: (search: Record<string, unknown>): { slack?: string } =>
    typeof search.slack === "string" && /^[a-z_]{1,32}$/.test(search.slack) ? { slack: search.slack } : {},
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("slack.getConnection", {})),
  component: SlackScreen,
});
